import { useMemo } from "react";
import * as staticDataService from "services/staticDataService";
import { selectTargetLossRatioRows } from "store/selectors/targetLossRatioSelectors";

export const TARGET_LOSS_RATIOS_CONFIG_KEY = "target_loss_ratios";

export const useTargetLossRatios = () => {
  const { data, isLoading } = staticDataService.useConfigQuery(
    TARGET_LOSS_RATIOS_CONFIG_KEY
  );
  const rows = useMemo(() => selectTargetLossRatioRows(data), [data]);
  return { rows, isLoading: !!isLoading };
};
